import React, {Component}    from "react";
import PropTypes             from "prop-types";
import Fetch                 from "qidigo-fetch";
import Logger                from "qidigo-logger";

import Loading               from "qidigo-components/loading";
import UserAddressPage       from "@app/views/dashboard/address";
import * as Sentry from "@sentry/react";

/**
 * "Contrôleur" pour l'édition (nouvelle, existante) d'adresse.
 *
 * UNE SEULE ADRESSE.
 *
 * @extends {Component}
 */
class UserAddressController extends Component {
	constructor() {
		super();
		this.state = {
			loading: true,
			errors:  false,
			saving:  false,
			confirmDeletion: false,
			address: null,
		};
	}

	//
	// Fetch the infos on mount.
	//
	componentWillMount() {
		// (The context is not available before mount.)
		this.fetchUserAddress();
	}

	fetchUserAddress() {
		const current = this.getCurrentlyEditing();
		if (current === true) {
			this.setState({loading: false, address: {}});

			return;
		}
		const id = parseInt(current);

		Fetch.get(`addresses/${id}`)
		.then((response) => {
			const address = response;
			address.state = address.state["id"];
			address.country = address.country["id"];
			
			this.setState({loading: false, address});

			return response;
		})
		.catch(Logger.catcher)
		.catch((err) => {
			this.goToListing();
		});
	}

	/**
	 * From the parameters, get what is currently edited.
	 *
	 * `true` meaning a new address.
	 */
	getCurrentlyEditing() {
		if (this.props.id) {
			return parseInt(this.props.id);
		}

		return true;
	}

	saveUserAddress() {
		const data = this.state.address;
		const address = {
			/* eslint-disable camelcase */
			civic_number_and_street:     data.civic_number_and_street,
			civic_number_ext:      data.civic_number_ext,
			postal_code: data.postal_code,
			country_id:  data.country,
			state_id:    parseInt(data.state),
			city_id:     data.city.id,
			/* esline-enable */
		};

		this.setState({saving: true});
		const current = this.getCurrentlyEditing();

		Sentry.addBreadcrumb({
			category: 'form_submit',
			level: Sentry.Severity.Debug,
			message: JSON.stringify(address)
		})

		const addressSaveCall = current === true ?
			Fetch.post(`users/${this.context.loggedUser.id}/addresses`, {address}) :
			Fetch.patch(`addresses/${current}`, {address})

		addressSaveCall
			.then((response) => {
				this.setState({saving: false});
				this.goToListing();

				return null;
			})
			.catch(Fetch.handleErrors(this));
	}

	onValueChange(field, e, value) {
		// Mutates state, but also sets state.
		const address = this.state.address;
		address[field] = value;
		this.setState({address});
	}
	onValidationError(errors) {
		this.setState({errors});
	}
	onSubmit() {
		this.setState({errors: false});
		this.setState({disabled: true});
		this.saveUserAddress();
	}

	handleCancelAction(e) {
		e.preventDefault();
		this.goToListing();
	}

	/**
	 * Call it once with `confirmation` falsey, use the set state
	 * to ask for confirmation, then re-call with confirmation truthy.
	 */
	handleDeleteAction(e, confirmation = false) {
		e.preventDefault();

		if (!confirmation) {
			this.setState({saving: true});
			this.setState({confirmDeletion: true});

			return;
		}

		if (confirmation === "cancel") {
			this.setState({saving: false});
			this.setState({confirmDeletion: false});

			return;
		}

		const current = this.getCurrentlyEditing();
		Fetch["delete"](`addresses/${current}`)
		.then((response) => {
			this.setState({saving: false});
			this.goToListing();

			return null;
		})
		.catch((errors) => {
			this.setState({confirmDeletion: false});

			return Promise.reject(errors);
		})
		.catch(Fetch.handleErrors(this))
		;
	}

	goToListing() {
		this.props.goToListing();
	}

	render() {
		const {
			...props
		} = this.props;
		if (this.state.loading) { return <Loading />; }

		const action = this.props.id ? "edit" : "new";

		return <UserAddressPage
			action={action}
			saving={this.state.saving}
			confirmDeletion={this.state.confirmDeletion}
			address={this.state.address}
			errors={this.state.errors}
			onChange={(...e)=>this.onValueChange(...e)}
			handleCancelAction={(...e)=>this.handleCancelAction(...e)}
			onSubmit={(...e)=>this.onSubmit(...e)}
			onValidationError={(errors)=>this.onValidationError(errors)}
			handleDeleteAction={(...e)=>this.handleDeleteAction(...e)}
			editedAddress={this.state.editedAddress}
			{...props}
		/>;
	}
}

UserAddressController.contextTypes = {
	loggedUser: PropTypes.object,
};

UserAddressController.propTypes = {
	id: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number,
	]),
	goToListing: PropTypes.func.isRequired,
};

export default UserAddressController;
